import { ReactComponent as LogoWhite } from "shared/assets/images/logo-strm.svg";
import { isMobile } from "react-device-detect";

interface ExportChapterCoverProps {
  id: string;
  title: string;
  refProp?: React.Ref<any>;
}
const ExportChapterCover: React.FC<ExportChapterCoverProps> = (props) => {
  const { id, title, refProp } = props;
  return (
    <div id={id} className="export-diagnose-chapter-cover-page" ref={refProp}>
      <LogoWhite
        style={{
          display: isMobile ? "block" : "none",
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <span className="chapter-cover-title">{title}</span>
      </div>

      <LogoWhite
        style={{
          position: "relative",
          bottom: 183,
          left: 490,
          width: 196,
          height: 58,
          display: isMobile ? "none" : "block",
        }}
      />
    </div>
  );
};

export default ExportChapterCover;
